import { useEffect, useRef } from "react";
import styles from "Styles/NameSuccessPage.module.css";
import emoji from "Assets/emoji/smiley.png";
import { Button } from "Components/Button.js";
import { useFormData } from "Contexts/FormDataContext";
import { useProgress } from "Contexts/ProgressContext";
import { useSession } from "Contexts/SessionContext";
import usePageContextUpdate from "Hooks/usePageContextUpdate";
import useSessionNavigate from "Hooks/useSessionNavigate";
import { useVisualContext } from "Contexts/VisualContext";
import { motion } from "framer-motion";
import {
  submitToHubSpot,
  formatFieldsForHubSpot,
  getSessionProperties,
} from "Lib/hubspot-utils";

export default function NameSuccessPage() {
  const { nextPage } = useProgress();
  const { currentFormData } = useFormData();
  const {
    userFirstName,
    userLastName,
    userEmail,
    companyName,
    industry,
    numEmployees,
  } = currentFormData;
  const { sessionNavigate } = useSessionNavigate();
  const { transitionState } = useVisualContext();
  const { sessionCode, isNewSession } = useSession();
  const hasSubmittedRef = useRef(false);

  useEffect(() => {
    const submitInitialForm = async () => {
      if (
        !sessionCode ||
        !userEmail ||
        !isNewSession ||
        hasSubmittedRef.current
      )
        return;
      hasSubmittedRef.current = true;

      const sessionProps = getSessionProperties(sessionCode, "Incomplete");

      const hubspotData = {
        firstname: userFirstName || "",
        lastname: userLastName || "",
        email: userEmail,
        company: companyName || "",
        industry: industry || "",
        numemployees: numEmployees || "",
        marketing_campaign: "Camp007-1",
        ...sessionProps,
      };

      const fields = formatFieldsForHubSpot(hubspotData);
      await submitToHubSpot(fields, {
        pageName: "Name Success - Session Started",
      });
    };

    submitInitialForm();
  }, [
    sessionCode,
    isNewSession,
    userFirstName,
    userLastName,
    userEmail,
    companyName,
    industry,
    numEmployees,
  ]);

  const variants = {
    in: {
      opacity: 1,
      x: 0,
    },
    out: {
      opacity: 0,
      x: -100,
    },
  };

  usePageContextUpdate();

  const handleClick = () => {
    sessionNavigate(`/form/${nextPage}`);
  };

  // TODO: if either firstName or lastName are null, this page should redirect or show an error. or both.
  return (
    <motion.div
      className={styles.container}
      key={"namesuccesswrapper"}
      transition={{
        type: "spring",
        ease: "easeIn",
        duration: 0.4,
      }}
    >
      <motion.div
        className={styles.content}
        initial={{
          opacity: 0,
          x: -200,
        }}
        animate={
          transitionState === "transitionOut" ? variants.out : variants.in
        }
        transition={{
          type: "spring",
          ease: "easeOut",
          duration: 0.8,
          bounce: 0.4,
        }}
      >
        <div className={styles.emojiWrapper}>
          <img className={styles.emoji} src={emoji} alt="smiley icon" />
        </div>
        <h1
          className={styles.heading}
        >{`很開心認識你， ${userFirstName} !`}</h1>
        <p className={styles.paragraph}>
          我們會透過幾個簡單的問題，協助你快速盤點目前的行銷佈局。
          <br />
          接下來的問題沒有對錯，照<strong>真實狀況</strong>填寫就好。
        </p>
        <p className={styles.paragraphWavy} style={{ marginTop: "1rem" }}>
          提醒你：每題送出後<strong>無法回上一題修改</strong>
          ；越貼近現況，我們越能幫上你的忙
        </p>

        <Button marginTop type="action" clickCB={handleClick}>
          OK
        </Button>
      </motion.div>
    </motion.div>
  );
}
